import React, {useMemo, useState} from 'react';
import {useSelector} from 'react-redux';
import AddDrugInventoryForm from '../../Components/AddDrugInventoryForm';
import useInventory from '../../hooks/useInventory';
import '../../styles/Patients.scss';
import DrugActions from './DrugActions';
import DrugFilters from './DrugFilters';
import DrugTable from './DrugTable';
import PageHeader from './PageHeader';

const DrugInventory = ({loaderchange, popupalert, popuptext}) => {
  const [filters, setFilters] = useState({search: ''});
  const [pagination, setPagination] = useState({pageIndex: 1, pageSize: 10});
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [editData, setEditData] = useState(null);

  const {tableData, dataCount, categories, vendors} = useInventory(filters, pagination, loaderchange, popupalert, popuptext);
  const sideactive = useSelector(state => state.counter.sidebarnav);

  const handleCreateDrugInventory = () => {
    setEditData(null);
    setIsPopupOpen(true);
  };

  const columns = useMemo(
    () => [
      {Header: 'Drug Name', accessor: 'name'},
      {Header: 'Dosage', accessor: 'dosage'},
      {Header: 'Category', accessor: 'category'},
      {Header: 'Generic Medicine', accessor: 'generic_name'},
      {Header: 'Quantity', accessor: 'quantity'},
      {Header: 'Vendor', accessor: 'vendor'},
      // {Header: 'Date', accessor: 'order_date'},
      {
        Header: 'Order Date',
        accessor: '',
        Cell: row => {
          const orderDate = row.row.original.order_date;
          const date = orderDate ? orderDate.split('-').reverse().join('-') : '—';

          return String(date);
        }
      },
      {
        Header: 'Actions',
        accessor: 'id',
        Cell: ({row}) => {
          if (!row.original || Object.keys(row.original).length === 0) {
            return <span>No Data</span>; // Handle empty row
          }
          return <DrugActions drugData={row.original} setEditData={setEditData} setIsPopupOpen={setIsPopupOpen} />;
        }
      }
    ],
    []
  );

  return (
    <div className={sideactive ? 'maincontainer-patient-sa' : 'maincontainer-patient'}>
      {isPopupOpen && (
        <AddDrugInventoryForm
          setCloseCreatePopup={setIsPopupOpen}
          loaderchange={loaderchange}
          popupalert={popupalert}
          popuptext={popuptext}
          editData={editData} // Pass edit data
          categories={categories} // Pass edit data
          vendors={vendors} // Pass edit data
          pagination={pagination}
        />
      )}

      <PageHeader title='Drug Inventory' cb={handleCreateDrugInventory} tableData={tableData} />

      <div className='row mt-4'>
        <div className='col-lg-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='patient'>
                <div className='table-content-patient'>
                  <DrugFilters filters={filters} setFilters={setFilters} setPagination={setPagination} />
                  <DrugTable data={tableData} columns={columns} pagination={pagination} setPagination={setPagination} datacount={dataCount} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DrugInventory;
